import React from 'react'
import styled from 'styled-components'
import { inheritPrimaryColor } from '../colors'
import DataCard from './data-card'
import ToolCard from './tool-card'

const Resources = styled(props => {
  return (
    <div {...props}>
      <Header css='margin-bottom: 0px;' children='Data' />
      <IntroText children="Below are some of the data upon which much of the team's research is based." />
      <Content>
        <DataCard
          href='https://data.mendeley.com/datasets/m7r4msjb4c/2'
          year='Nik-Zainal, 2019'
          children='A compendium of mutational signatures of environmental agents'
        />
        <DataCard
          href='ftp://ftp.sanger.ac.uk/pub/cancer/Zou_et_al_2017'
          year='Zou et al., 2017'
          children='Validating the concept of mutational signatures with isogenic cell models'
        />
        <DataCard
          href='ftp://ftp.sanger.ac.uk/pub/cancer/Nik-ZainalEtAl-560BreastGenomes'
          year='Nik-Zainal et al., 2016'
          children='Landscape of somatic mutations in 560 breast cancer whole-genome sequences'
        />
        <DataCard
          href='ftp://ftp.sanger.ac.uk/pub/cancer/Nik-ZainalEtAl'
          year='Nik-Zainal et al., 2012'
          children='Mutational processes molding the genomes of 21 breast cancers'
        />
      </Content>
      <Header css='margin-top: 30px;' children='Tools' />
      {/* <IntroText children='Below are the tools developed by the team for public use.' /> */}
      <Content css='margin-top: 20px;'>
        <ToolCard
          href='https://signal.mutationalsignatures.com'
          title='Signal'
          imgSrc='/public/signalnew.svg'
          children={`
            Signal is a web platform designed to allow users to easily explore some of the mutational
            signature data and analysis results generated by the team. Signal contains data and
            and signatures from cancer samples as well as isogenic cell-based experiments involving
            gene knockouts and exposure to environmental mutagens.
            Users can also upload their own samples for analysis by our bespoke signature analysis platform.
          `}
        />
        <ToolCard
          href='https://github.com/Nik-Zainal-Group/signature.tools.lib'
          title='signature.tools.lib'
          imgSrc='/public/githubnew.svg'
          children={`
            signature.tools.lib is an R package containing many of the algorithms developed and used by the
            team to perform their research, including signature extraction and fitting. This software is open
            source, and users are welcome to use these algorithms to aid in their own research.
          `}
        />
      </Content>
    </div>
  )
})`
  margin-top: 30px;
  margin-bottom: 20px;
  color: rgb(100, 100, 100);
  font-size: 1.1em;
  line-height: 26px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const IntroText = styled.p`
  width: 100%;
  max-width: 1140px;
  color: rgb(150, 150, 150);
`
const Header = styled.h1`
  color: ${inheritPrimaryColor};
  width: 100%;
  max-width: 1140px;
`
const Content = styled.div`
  width: 100%;
  max-width: 1140px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;
`

export default Resources